import { action as apiAction } from 'api/Api'
import {
  setResponsible
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  userId: number
}

export default (payload: Payload) => async dispatch => {
  const { id, userId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setResponsible({
    id,
    responsible: userId
  }))

  try {
    await apiAction('MakeUserResponsible', {
      cardId: id,
      userId
    })
  } finally {
    optimisticAction.revert()
  }
}
